import React, { ComponentType } from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'

export interface ProviderProps {
  disableBackdropClick(): void
  enableBackdropClick(): void
  handleKeyDown(event: KeyboardEvent): void
}

const DrawerLockingContext: React.Context<ProviderProps> = React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  disableBackdropClick: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  enableBackdropClick: () => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  handleKeyDown: (event: KeyboardEvent) => {
    if (!event) {
      throw new Error('Handle key down needs an event')
    }
  },
})
export const DrawerLockingContextProvider = DrawerLockingContext.Provider

export interface WithDrawerLockingContextInjectedProps {
  drawerLockingContext: ProviderProps
}

export const withDrawerLockingContext = (
  Component: ComponentType<WithDrawerLockingContextInjectedProps>,
) => {
  const C = (props: React.ComponentProps<typeof Component>) => {
    return (
      <DrawerLockingContext.Consumer>
        {(value: ProviderProps) => {
          return <Component {...props} drawerLockingContext={value} />
        }}
      </DrawerLockingContext.Consumer>
    )
  }

  return hoistNonReactStatics(C, Component)
}
